import {Dto} from "common";

export class BodyWeightActivityResultsModel extends Dto {
    public weight: number;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
